import { storageLocation } from "./storageLocation";
import { storage } from "../firebase/firebase.utils";

// Firebase v8 transport. Components keep their own pickers and document writes.
export default async function uploadFile({ file, fullPath, userId, parent, contentType, onProgress }) {
  if (!file || !fullPath || !userId) throw new Error("Missing upload file, destination, or user.");
  const location = storageLocation(fullPath, parent, userId);
  if (!location) throw new Error("This upload destination is not configured.");
  const uploadedAt = new Date().toISOString();
  const name = file.name || fullPath.split("/").pop();
  const type = contentType || file.type || "application/octet-stream";
  const task = storage.ref(fullPath).put(file, {
    contentType: type,
    customMetadata: {
      storageVersion: "1",
      spaceId: location.spaceId || "",
      stationId: location.stationId || "",
      group: location.group,
      category: location.category,
      uploadedBy: String(userId),
      uploadedAt,
      name,
      ...(parent ? { parent } : {}),
    },
  });
  await new Promise((resolve, reject) => {
    task.on(
      "state_changed",
      (snapshot) => {
        const bytes = snapshot.bytesTransferred;
        const total = snapshot.totalBytes;
        onProgress?.({ bytes, total, progress: total ? bytes / total : 0 });
      },
      reject,
      resolve,
    );
  });
  const url = await task.snapshot.ref.getDownloadURL();
  return { url, fullPath: task.snapshot.ref.fullPath, uploadedAt, name, type, size: file.size };
}
